export class LineChartData {
    lines: Line[]
    steps: number

    constructor() {
        this.lines = []
        this.steps = 0
    }

    add(points: number[], color: string) {
        const line = new Line(points, color)
        this.lines.push(line)
        this.steps = (this.steps < line.getLength()) ? line.getLength() : this.steps
    }

    getColors() {
        const colors = []
        let atleastOneColorSetFlag = false
        for (const line of this.lines) {
            const color = line.getColor()
            if (color) {
                atleastOneColorSetFlag = true
                colors.push(color)
            } else {
                colors.push('#000')
            }
        }

        return atleastOneColorSetFlag ? colors : null
    }
}

class Line {
    private points: number[]
    private color?: string

    constructor(points: number[], color: string) {
        this.points = points
        this.color = color
    }

    getPoint(xValue: number) {
        if (this.points.length === 1) {
            return this.points[0]
        } else {
            return this.points[xValue]
        }
    }

    getLength() {
        return this.points ? this.points.length : 0
    }

    getColor() {
        return this.color
    }
}


